module.exports = __webpack_public_path__ + "static/media/products-1.fd0284c9.svg";